<template>
  <div :class="route.name === 'configuration' ? 'sys-main' : ''">
    <!-- <router-view /> -->
    <div class="sys-content" v-if="route.name === 'configuration'">
      <div class="sys-box">
        <div class="sys-icon" @click="createFile">
          <!-- <i class="iconfont icon-xinzeng" ></i> -->
          <img src="../assets/xinzeng_icon.png" alt="">
          <div class="sys-name f-s-18">{{ $t('createNewProject') }}</div>
        </div>
      </div>
      <div class="sys-box">
        <div class="sys-icon" @click="openProject">
          <!-- <i class="iconfont icon-xiangmutubiao"></i> -->
          <img src="../assets/project_icon.png" alt="">
          <div class="sys-name f-s-18">{{ $t('openExistingProject') }}</div>
        </div>
      </div>
      <div class="sys-box">
        <div class="sys-icon" @click="loadFile">
          <!-- <i class="iconfont icon-dakai"></i> -->
          <img src="../assets/folder_icon.png" alt="">
          <div class="sys-name f-s-18">{{ $t('loadConfigFile') }}</div>
        </div>
      </div>
    </div>
    <div class="version">{{ $t('version') }}: {{ version }}</div>
    <projectDialog :DialogVisible='DialogVisible' :DialogTitle='DialogTitle' @close='closeProjectDialog' @goRouter='goRouter'></projectDialog>
    <projectLead :DialogVisible='leadVisible'  @close='closeProjectLead' @goRouter='goRouter'></projectLead>
    <configInfo v-if="infoDialog" :DialogVisible='infoDialog' :projectName="projectName" @close='closeProjectinfo' :data='panelsData'></configInfo>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getVersion } from '../api/config.js'
import projectDialog from './configFile/configNew.vue'
import configInfo from './configFile/configInfo.vue'
import projectLead from './configFile/projectLeading.vue'
export default {
  name: 'SystemList',
  data () {
    return {
      routeName: this.$route.name,
      DialogVisible: false,
      DialogTitle: this.$t('projectDialogNew'),
      leadVisible:false,
      infoDialog:false,
      panelsData:[],
      version:''
    }
  },
  components: {
    projectDialog: projectDialog,
    projectLead: projectLead,
    configInfo: configInfo,
  },
  computed: {
    ...mapState([
      'route'
    ])
  },
  created () {
    getVersion().then(res=>{
      if(res.code == 1){
        this.version = res.data
      }
    })
  },
  methods: {
    ...mapActions([
      'changeProjectVisible'
    ]),
    createFile () {
      this.DialogVisible = true
    },
    closeProjectDialog () {
      this.DialogVisible = false
    },
    closeProjectLead () {
      this.leadVisible = false
    },
    loadFile () {
      this.leadVisible = true
    },
    closeProjectinfo(){
      this.infoDialog = false;
    },
    goRouter (data){
      if(data.length === 1){
        let item = data.panels[0]
        this.$router.push({path:'/systemSettings',query:{
            panelId:item.id,
            panelNo:item.panelNo,
            projectId:item.projectId,
            projectName: data.site
        }})
      }else{
        this.panelsData = data.panels;
        this.projectName = data.site
        this.infoDialog = true;
      }
      
    },
    openProject () {
      this.changeProjectVisible(true)
    }
  }
}
</script>

<style lang="less" scoped>
  .sys-main {
    height: calc(100vh - 78px);
    display: flex;
    justify-content: center;
    align-items: center;
    .sys-content {
      width: 1060px;
      cursor: pointer;
      .sys-box {
        float: left;
        margin-right: 80px;
        &:last-child {
          margin-right: 0;
        }
        .sys-icon {
          width: 300px;
          height: 300px;
          background-color: #fff;
          border-radius: 6px;
          text-align: center;
          &:hover {
            box-shadow:0px 3px 24px 0px rgba(131, 155, 144, 0.35);
          }
          img {
            margin: 56px 30px;
            width: 120px;
          }
          // i {
          //   font-size: 100px;
          //   color: #666;
          //   line-height: 210px;
          // }
        }
        .sys-name {
          // margin-top: 18px;
          text-align: center;
          color: #959595;
        }
      }
    }
    .version {
      position: absolute;
      bottom: 10px;
      left: 50%;
      font-size: 16px;
      transform: translateX(-50%);
    }
  }
</style>
